import { render, staticRenderFns } from "./JsonDecoderConfiguration.vue?vue&type=template&id=4706678f&"
import script from "./JsonDecoderConfiguration.vue?vue&type=script&lang=ts&"
export * from "./JsonDecoderConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports